import * as React from "react";
import { Text } from "react-native";
import type { Habit } from "habits/types";
import { getHabitUrl } from "habits/util";
import { useNavigate } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import { useSelector } from "react-redux";
import { getNextHabit } from "habits/selectors";
import type { State } from "store";
import HabitSummary from "./HabitSummary";

export type StateProps = {
  habits: Habit[] | null;
  isHabitsLoaded: boolean;
  isLoggedIn: boolean | null | undefined;
};
export type DispatchProps = {};
export type OwnProps = {};
export type Props = StateProps & DispatchProps & OwnProps;

function StartButton(props: {
  nextHabit: Habit | null;
  onPress: (url: string) => void;
}) {
  if (props.nextHabit == null || props.nextHabit.destination == null) {
    return null;
  } else {
    const url = getHabitUrl(
      props.nextHabit.destination,
      props.nextHabit.habitId
    );

    return (
      <button
        className="btn btn-outline-primary"
        onClick={() => props.onPress(url)}
      >
        Start
      </button>
    );
  }
}

function ShareButton(props: { habits: Habit[] }) {
  if (props.habits.length === 0) {
    return null;
  } else {
    const onClick = async () => {
      const text = props.habits
        .filter((habit) => habit.isComplete === true)
        .map((habit) => "✅ " + habit.title)
        .join("\n");
      const data = {
        title: "Conduct",
        /** TODO, create a URL that links to the shared habits */
        url: "https://ruggedbrain.com",
        text: text,
      };
      await navigator.share(data);
    };

    return (
      <button className="btn btn-outline-primary" onClick={onClick}>
        Share
      </button>
    );
  }
}

export default function Menu(props: Props) {
  const nav = useNavigate();
  const nextHabit = useSelector<State, Habit | null>((state) =>
    getNextHabit(state, null)
  );

  if (props.isLoggedIn == null || props.habits == null) {
    return null;
  }

  if (props.isLoggedIn === false) {
    return (
      <div className="MenuContainer">
        <Text>
          Welcome to <b>Conduct</b>
        </Text>
      </div>
    );
  }

  if (!props.isHabitsLoaded) {
    return (
      <div className="MenuContainer">
        <Text>Loading...</Text>
      </div>
    );
  }

  if (props.isHabitsLoaded && props.habits.length === 0) {
    return (
      <div className="MenuContainer">
        <Text>
          Looks like you haven't added any habits yet. You can add habits on the{" "}
          <LinkContainer
            to="/manage"
            style={{
              fontWeight: "bold",
            }}
          >
            <div>manage habits screen</div>
          </LinkContainer>{" "}
          under settings.
        </Text>
      </div>
    );
  }

  const onPress = (url: string) => nav(url);

  /** todo, fix the habits so they only show once we have all the log data */
  const topButton =
    nextHabit != null && nextHabit.destination != null ? (
      <StartButton onPress={onPress} nextHabit={nextHabit} />
    ) : (
      <ShareButton habits={props.habits} />
    );

  const buttons = props.habits.map((habit) => (
    <HabitSummary
      key={habit.habitId}
      isComplete={habit.isComplete === true}
      habit={habit}
    />
  ));

  return (
    <div className="MenuContainer">
      {topButton}
      {buttons}
    </div>
  );
}
